// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Arrow_wrapper__3hr5V","img":"Arrow_img__3mM8C","left":"Arrow_left__2FnUw","right":"Arrow_right__3bXaL","show":"Arrow_show__19G7U","hide":"Arrow_hide__3fK8J"};